import React from 'react';

import MenuMobileList from '../MenuMobileList';

const AccountMenu: React.FC = () => {
  // avoid menu distortion when session is loding
  return <MenuMobileList />;
};

export default React.memo(AccountMenu);
